export default __webpack_public_path__ + "static/media/ceramol-iage-result-keep-fresh.cee44ee2.png";